module.exports = __webpack_public_path__ + "2bd8e05f60c61b7ced4d9cb064afd874.mp3";